import {
  BY_PRACTICE_AREA,
  BY_CASE_MATTER,
  BY_EVENT_GUESTS,
  BY_EVENT_LOCATION,
  BY_EVENT_TYPE,
  BY_TASK_PRIORITY,
  BY_TASK_DUE_DATE,
  BY_LEAD_STAGE,
  BY_POTENTIAL_CASE_VALUE,
  BY_LEAD_PRIORITY,
  BY_TAG,
  BY_CASE_STAGE,
  BY_CASE_CLOSURE_REASON,
  BY_CASE_OUTCOME,
  VIEWED_UNVIEWED,
  BY_VENUE,
} from 'constants/automationConstants';

export const commonFilterOptions = [
  { label: BY_PRACTICE_AREA, value: BY_PRACTICE_AREA },
  { label: BY_CASE_MATTER, value: BY_CASE_MATTER },
  { label: BY_VENUE, value: BY_VENUE },
];

export const eventFilterOptions = [
  { label: BY_EVENT_GUESTS, value: BY_EVENT_GUESTS },
  { label: BY_EVENT_LOCATION, value: BY_EVENT_LOCATION },
  { label: BY_EVENT_TYPE, value: BY_EVENT_TYPE },
  { label: BY_PRACTICE_AREA, value: BY_PRACTICE_AREA },
  { label: BY_VENUE, value: BY_VENUE },
  { label: BY_CASE_MATTER, value: BY_CASE_MATTER },
];
export const taskFilterOptions = [
  { label: BY_TASK_PRIORITY, value: BY_TASK_PRIORITY },
  { label: BY_TASK_DUE_DATE, value: BY_TASK_DUE_DATE },
  { label: BY_PRACTICE_AREA, value: BY_PRACTICE_AREA },
  { label: BY_VENUE, value: BY_VENUE },
  { label: BY_CASE_MATTER, value: BY_CASE_MATTER },
];
export const billingFilterOptions = [
  { label: BY_PRACTICE_AREA, value: BY_PRACTICE_AREA },
  { label: BY_VENUE, value: BY_VENUE },
  { label: BY_CASE_MATTER, value: BY_CASE_MATTER },
];

export const pastDueFilterOptions = [...billingFilterOptions, { label: VIEWED_UNVIEWED, value: VIEWED_UNVIEWED }];

export const caseFilterOptions = [
  ...commonFilterOptions,
  { label: BY_CASE_STAGE, value: BY_CASE_STAGE },
  { label: BY_CASE_CLOSURE_REASON, value: BY_CASE_CLOSURE_REASON },
  { label: BY_CASE_OUTCOME, value: BY_CASE_OUTCOME },
];
export const fileFilterOptions = [...commonFilterOptions];
export const contactFilterOptions = [...commonFilterOptions];

export const leadFilterOptions = [
  ...commonFilterOptions,
  { label: BY_LEAD_STAGE, value: BY_LEAD_STAGE },
  { label: BY_POTENTIAL_CASE_VALUE, value: BY_POTENTIAL_CASE_VALUE },
  { label: BY_TAG, value: BY_TAG },
  { label: BY_LEAD_PRIORITY, value: BY_LEAD_PRIORITY },
];
